<template>
    <div class="toggle">
        <el-dropdown class="menu-item" @command="handleCommand">
            <div class="el-dropdown-link">
                <span>{{ checkdApplyName }}</span><i class="el-icon-arrow-down"></i>
            </div>
            <el-dropdown-menu slot="dropdown" class="menu-dropdown">
                <el-dropdown-item :command="item" v-for="(item, index) in applyList" :key="index">{{
          item.applyName
        }}</el-dropdown-item>
            </el-dropdown-menu>
        </el-dropdown>
    </div>
</template>

<script>
import { mapMutations, mapGetters, mapActions } from 'vuex';
export default {
  // inject: ['reload'],
  name: 'appToggle',
  data() {
    return {
      applyList: [],
      selectedApply: {}, //当前选中的应用
    };
  },
  computed: {
    ...mapGetters('main', ['checkdApplyName']),
  },
  methods: {
    ...mapMutations('main', ['setcheckdApplyName']),
    ...mapActions('main', ['getMerchantInfo']),
    getApplyList() {
      // 登陆成功后获取应用列表
      this.$api.APPLY.getAllApply({ companyId: JSON.parse(localStorage.getItem('loginUesr')).companyInfo.id }).then(
        (res) => {
          this.applyList = res;
          if (localStorage.getItem('checkdApply')) {
            //登录有缓存时
            this.selectedApply = JSON.parse(localStorage.getItem('checkdApply'));
          } else {
            //登录无缓存时
            this.selectedApply = res[0];
          }
          this.setcheckdApplyName(this.selectedApply);
          if (this.selectedApply === 'HEEMONEY') {
            //判断是汇付宝应用调用获取主商户信息接口，后面有需要用到
            this.getMerchantInfo({ applyCode: this.selectedApply.applyCode });
          }
          localStorage.setItem('checkdApply', JSON.stringify(this.selectedApply));
        },
      );
    },
    // 切换应用
    async handleCommand(item) {
      localStorage.setItem('checkdApply', JSON.stringify(item));
      this.setcheckdApplyName(item);
      if (item.applyType === 'HEEMONEY') {
        //应用如果为汇付宝 获取主商户的详情 后面的接口有需要这个接口的数据
        await this.getMerchantInfo({ applyCode: item.applyCode });
      }
      this.$router.go(0);
      // await this.reload();
    },
  },
  mounted() {
    this.getApplyList();
  },
};
</script>

<style lang="less" scoped>
@import '~@/assets/style/mixins.less';
@import '~@/assets/style/var.less';
.toggle {
  width: 100%;
  background-color: @bg-white;
  .box_row_column_center();
}
.menu-item {
  height: 54px;
  line-height: 54px;
  color: @font-color-black;
  font-size: @aside-font-size;
}
.el-icon-arrow-down {
  margin-left: 0.7em;
}
.menu-dropdown{
   height: 94%;
   overflow-y: scroll;
}
</style>
